export const SHARING_ENABLED = true;
export const SAMPLE_FILES_ENABLED = true;
export const WISHARING_ENABLED = false && false;
export const SAMPLE_WISHES_ENABLED = false && false;
export const WISHING_ENABLED = false;
export const WISHING_HIDDEN = false;
export const DEFAULT_THEME = 'sayaka';
